export enum CoverageMode {
	Automatic = 'AUTOMATIC',
	Manual = 'MANUAL'
}
